<template>
  <div id="header-profile">
    <b-dropdown aria-role="list">
      <template #trigger>
          <div class="profile-icon-container">
            <b-image class="profile-icon" :src="photoURL" rounded ratio="1by1" />
          </div>
      </template>
      <router-link :to="`/live/console/${recentLiveId}?type=recentLive`">
        <b-dropdown-item
          v-if="isPerformer && isStreaming"
          aria-role="menuitem"
          id="live-console-menu-item"
        >
          <b-icon icon="monitor"></b-icon>
          配信中のライブ
        </b-dropdown-item>
      </router-link>
      <router-link :to="isPerformer ? '/cast/mypagetop' : '/mypagetop'">
        <b-dropdown-item aria-role="menuitem"> マイページ </b-dropdown-item>
      </router-link>
      <router-link to="#">
        <b-dropdown-item aria-role="menuitem" @click="signOut">
          サインアウト
        </b-dropdown-item>
      </router-link>
    </b-dropdown>
    <div class="profile-info" v-if="!isPerformer" @click="moveToDoronPurchase">
      <div class="doron-info-container">
        <div class="doron-icon-container">
          <img src="@/assets/image/doron/doron.svg" alt="" />
        </div>
        <div class="doron-amount-container">
          {{ doronAmount }}
        </div>
      </div>
      <div class="doron-info-container">
        <div class="doron-icon-container">
          <img src="@/assets/image/doron/doronFree.svg" alt="" />
        </div>
        <div class="doron-amount-container">
          {{ freeDoronAmount }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from '@/plugins/firebase';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'HeaderProfile',
  created() {
    this.$store.dispatch('user/loadUserDoc');
  },
  computed: {
    ...mapGetters('user', ['isStreaming', 'isPerformer', 'recentLiveId']),
    ...mapGetters('doron', ['doronAmount']),
    ...mapGetters('doron', ['freeDoronAmount']),
    ...mapState('user', ['nickname']),
    defaultPhotoURL() {
      return 'https://firebasestorage.googleapis.com/v0/b/pandora-988f8.appspot.com/o/all%2Fdefault-user-icon.png?alt=media&token=4a1a4307-1990-4c99-a944-9b8d289e1a50';
    },
    photoURL() {
      return this.$store.state.user.photoURL || this.defaultPhotoURL;
    }
  },
  methods: {
    async signOut() {
      await auth.signOut().catch(err => {
        console.error(err);
      });
      await this.$store.dispatch('live/initStore');
      this.$store.dispatch('auth/signOut');
      this.$router.push({ path: '/signin', force: true });
    },
    moveToDoronPurchase() {
      this.$router.push('/mypage/doronPurchase');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/header-profile.scss';
</style>

<style>
.dropdown-menu {
  left: auto !important;
  right: -85px;
}
</style>
